import request from '@/utils/request'
import qs from 'qs'

/**
 * 获取项目列表
 * @param param
 */
export function fetchList(page) {
    return request({
        url: '/api/rep/dictionaries/list',
        method: 'post',
        data:page
    })
}

/**
 * 获取维度列表
 * @param param
 */
export function fetchDegreeList() {
    return request({
        url: '/api/rep/dictionaries/degree/list',
        method: 'post',
    })
}
/**
 * 获取维度分类列表
 * @param param
 */
export function findCategory() {
    return request({
        url: '/api/rep/dictionaries/type/list',
        method: 'post',
    })
}

/**
 * 新增字典分类
 * @param param
 */
export function saveCategory(query) {
    return request({
        url: '/api/rep/dictionaries/type/save',
        method: 'post',
        data: query
    })
}
/**
 * 更新字典分类
 * @param param
 */
export function updateCategory(query) {
    return request({
        url: '/api/rep/dictionaries/type/update',
        method: 'post',
        data: query
    })
}

/**
 * 删除字典分类
 * @param param
 */
export function removeCategory(id) {
    return request({
        url: `/api/rep/dictionaries/type/delete/${id}`,
        method: 'post'
    })
}

/**
 * 新增字典
 * @param param
 */
export function save(query) {
    return request({
        url: '/api/rep/dictionaries/save',
        method: 'post',
        data: query
    })
}


/**
 * 修改字典
 * @param param
 */
export function update(query) {
    return request({
        url: '/api/rep/dictionaries/update',
        method: 'post',
        data: query
    })
}

/**
 * 获取字典
 * @param param
 */
export function get(id) {
    return request({
        url: '/api/rep/dictionaries/get/' + id,
        method: 'get'
    })
}

/**
 * 删除字典
 * @param param
 */
export function remove(id) {
    return request({
        url: '/api/rep/dictionaries/delete/' + id,
        method: 'post'
    })
}

/**
 * 获取类别
 * @param param
 */
export function findDegrees() {
    return request({
        url: '/api/rep/dictionaries/degree',
        method: 'get'
    })
}
